import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { shelfItemShape, ugcRatingShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import Rating from '@bibliocommons/rating';
import { SHELF_NAMES } from '../../../../constants/ShelfConstants';

export default class RatingsInfo extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUpdateRating', 'handleRemoveRating', 'renderRating');
  }

  handleUpdateRating(rating) {
    // updates existing rating
    if (this.props.ownerRatingForBib) {
      return this.props.ratingsActions.changeItemRating(this.props.item.get('metadataId'), rating);
    }

    // adds new rating
    return this.props.ratingsActions.rateItem(this.props.item.get('metadataId'), rating);
  }

  handleRemoveRating() {
    return this.props.ratingsActions.removeItemRating(this.props.item.get('metadataId'), this.props.ownerRatingForBib.get('id'));
  }

  renderRating() {
    const { item, owner, ownerRatingForBib, ratingsTransactions } = this.props;
    const metadataId = item.get('metadataId');
    const rating = ownerRatingForBib ? ownerRatingForBib.get('rating') : 0;
    const isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);


    if (owner.get('loggedIn')) {
      return (
        <div className="shelf-owner-rating">
          <ScreenReaderMessage>
            <FormattedMessage id="label_my_rating" />
          </ScreenReaderMessage>
          <Rating
            rating={rating}
            isLoading={isLoading}
            id={`shelf-owner-rating-${metadataId}`}
            handleButtonClick={this.handleUpdateRating}
            handleRemoveClick={this.handleRemoveRating} />
        </div>
      );
    }

    const username = owner.get('name');

    return (
      <div className="shelf-public-rating">
        <ScreenReaderMessage>
          <FormattedMessage id="users_rating" values={{ username }} />
        </ScreenReaderMessage>
        <Rating
          readOnly
          variant="blue"
          rating={rating}
          id={`shelf-public-rating-${metadataId}`} />
      </div>
    );
  }

  render() {
    const { shelfName, owner, ownerRatingForBib } = this.props;

    // Hide ratings on the `for later` shelf.
    if (shelfName === SHELF_NAMES.FOR_LATER) {
      return null;
    }

    // Display the owner's rating and allow the owner to add/update their rating.
    if (ownerRatingForBib || owner.get('loggedIn')) {
      return (
        <div className="cp-shelf-list-item-ratings-info">
          {this.renderRating()}
        </div>
      );
    }

    return null;
  }
}

RatingsInfo.propTypes = {
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  shelfName: PropTypes.string.isRequired,
  ownerRatingForBib: ugcRatingShape,
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  ratingsActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/RatingsInfo/RatingsInfo.jsx